import { StatutAudit } from '../../../core/api/client/models';

/* eslint-disable @typescript-eslint/naming-convention */
export namespace StatutAnomalie {
    export const StatutEnum = {
        Supprime: 'Anomalie supprimée' as StatutAudit
    };
}
